import _ from 'underscore';
import { curlyTemplate } from '@bingads-webui-universal/primitive-utilities';

// Runtime does not support i18n now, use this function to mock the i18n.getString().
// It's totally same except there is no translation result
export const i18nGetString = (key, model, {
  preprocess = _.identity,
} = {}) => {
  let ret = key;

  if (!_.isString(key)) {
    throw new Error('Localization key must be a String');
  }

  if (ret) {
    ret = preprocess(ret);

    if (!_.isString(ret)) {
      throw new Error(`Preprocess function must return a String. ${key}`);
    }

    if (model) {
      const compiled = curlyTemplate(ret);

      ret = compiled(model);
    }
  }

  return ret;
};
